import { Box, Popover, TextField } from '@material-ui/core';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import dayjs from 'dayjs';
import { useLocation } from 'umi';
import { DatePicker } from '@material-ui/lab';
import { useDispatch, useSelector } from 'dva';
import Bar from './components/Bar';
import UserInformation from './components/UserInformation';
import TooltipML from './components/Tooltip';
import TimeLineML from './components/TimeLine';
import IndexStyled from './indexStyled';

export default () => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id } = query;
  const { trackingLogTotal } = useSelector((state) => state.userBehavior);
  const [sortData, setSortData] = useState({
    label: '按时间正序加载',
    value: '1',
  });
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(
    dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
  );
  const sortList = [
    { label: '按时间倒序加载', value: '0' },
    { label: '按时间正序加载', value: '1' },
  ];
  const handleClick = () => {
    setOpen(!open);
  };
  const handleChoose = (data) => {
    setOpen(!open);
    setSortData(data);
    dispatch({
      type: 'userBehavior/trackingLogTrajectorysort',
      payload: {
        values: data,
      },
    });
  };

  const handleClose = () => {
    setOpen(!open);
  };
  const handleDateChange = (day) => {
    fetchTrackingLogTrend(day);
  };

  //获取用户行为明细 轨迹
  const fetchTrackingLogTrajectory = useCallback(() => {
    dispatch({
      type: 'userBehavior/getTrackingLogTrajectory',
      payload: {
        values: {
          userid: id,
          queryDate: date,
        },
      },
    });
  }, [dispatch, id, date]);
  //获取用户行为明细数据 趋势
  const fetchTrackingLogTrend = useCallback(
    (calcDay) => {
      dispatch({
        type: 'userBehavior/getTrackingLogTrend',
        payload: {
          values: {
            userid: id,
            calcDay,
          },
        },
      });
    },
    [dispatch, id],
  );
  //获取用户属性信息
  const fetchUserinfo = useCallback(() => {
    dispatch({
      type: 'userBehavior/getTrackingUserDetail',
      payload: {
        values: {
          userid: id,
          startDate: dayjs().subtract(29, 'day').format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
        },
      },
    });
  }, [dispatch, id]);
  useEffect(() => {
    fetchTrackingLogTrend(7);
    fetchUserinfo();
  }, [fetchTrackingLogTrend, fetchUserinfo]);
  useEffect(() => {
    fetchTrackingLogTrajectory();
  }, [fetchTrackingLogTrajectory]);

  return (
    <IndexStyled>
      <Box id="user_behavior_detail">
        {/* 上面部分 */}
        <Box display="flex" gap="24px">
          {/* 左边 */}
          <Box width="100%" height="255px" flexShrink="1" className="bar-style">
            <Bar height="255px" handleDateChange={handleDateChange} />
          </Box>
          {/* 右边 */}
          <Box
            width="400px"
            height="255px"
            flexShrink="0"
            className="info-style"
          >
            <UserInformation />
          </Box>
        </Box>

        {/* 下面的部分 */}
        <Box width="100%" className="bar-style second_section" mt={3}>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" flex="1">
              用户行为轨迹
              <TooltipML info="以日为维度展示用户单日的平台行为日志" />
            </Box>
            <Box flex="1" className="sort-wrap">
              <span style={{ color: '#333' }}>{sortData.label}</span>
              <div ref={ref} class="bottom-arrow" onClick={handleClick}></div>
              <Popover
                open={open}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                overlayStyle={{ width: '108px' }}
                arrowPointAtCenter
                anchorEl={ref.current}
                onClose={handleClose}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  gap="14px"
                  sx={{ padding: '10px 12px' }}
                >
                  {sortList.map((item) => (
                    <Box onClick={() => handleChoose(item)} key={item.value}>
                      {item.label}
                    </Box>
                  ))}
                </Box>
              </Popover>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            mt={2.5}
            border="1px solid #ccc"
            padding="10px"
            alignItems="self-end"
          >
            <DatePicker
              value={date}
              label=""
              inputFormat="yyyy-MM-dd" //时间格式化
              onChange={(newValue) => {
                setDate(dayjs(newValue).format('YYYY-MM-DD'));
              }}
              // minDate={new Date()}
              renderInput={(params) => {
                return (
                  <Box>
                    <TextField
                      sx={{
                        height: 'auto',
                        display: 'flex',
                        alignItems: 'flex-end',
                      }}
                      variant="standard"
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: '请选择时间',
                        readonly: 'readonly',
                      }}
                    />
                  </Box>
                );
              }}
            />
            <span style={{ color: '#333' }}>
              事件总数：{trackingLogTotal || 0}
            </span>
          </Box>
          <Box mt={2.5} className="timeline_wrapper">
            <TimeLineML />
          </Box>
        </Box>
      </Box>
    </IndexStyled>
  );
};
